import React from 'react';
import { Navigate, Outlet, Route } from 'react-router-dom';
import { SettingsNav, SettingsNavItem } from './SettingsNav';
import SettingsNavDropDown from './SettingsNavDropDown';

export type SettingsTabConfig = SettingsNavItem & {
    content: () => JSX.Element;
    /** Route path for the tab, when it differs from `url` (e.g. `invoices/:page?`). */
    path?: string;
    /** Child routes beneath the tab; `content` then renders as the tab's index route. */
    routes?: JSX.Element[];
};

/**
 * The child routes of a TabbedSettings section: an index redirect to the first tab, one route per
 * tab, and a catch-all back to the section. Nest them under the route whose element renders
 * `<TabbedSettings>`.
 */
export function tabRoutes(navItems: SettingsTabConfig[]): JSX.Element {
    const first = navItems[0];
    return (
        <>
            {first && <Route index element={<Navigate to={first.url} replace />} />}
            {navItems.map((tab) =>
                tab.routes ? (
                    <Route key={tab.url} path={tab.path ?? tab.url}>
                        <Route index element={tab.content()} />
                        {tab.routes}
                    </Route>
                ) : (
                    <Route key={tab.url} path={tab.path ?? tab.url} element={tab.content()} />
                )
            )}
            <Route path="*" element={<Navigate to=".." replace />} />
        </>
    );
}

type TabbedSettingsProps = {
    navItems: SettingsTabConfig[];
    sectionName?: string;
};

/** The tab nav for a section, with an `<Outlet/>` for the child routes built by `tabRoutes`. */
export default class TabbedSettings extends React.Component<TabbedSettingsProps> {
    render() {
        const navItems = this.props.navItems;
        return (
            <div className="pagedSettings">
                <div className="d-none d-lg-block">
                    <SettingsNav navItems={navItems} />
                </div>
                <div className="d-lg-none settingsNavDropdownWrap">
                    <SettingsNavDropDown navItems={navItems} sectionName={this.props.sectionName} />
                </div>

                <div className="pagedSettingsContent">
                    <Outlet />
                </div>
            </div>
        );
    }
}
